import React, {useMemo} from "react";
import {useMatch} from "@tanstack/react-location";
import {Box, Flex, HStack, Button, Heading, useMediaQuery} from "@chakra-ui/react";
import {HeaderContainer, Loader, ActionMenu} from "@onemind-services-llc/ui-components";
import {FiMonitor} from "@onemind-services-llc/react-icons-ng/fi";
import {useGetDeviceApiDcimDevicesIdGet} from "../../../orval-cml/default/default";

const BaremetalDetailsHeader = () => {
  const [isMobileOrIpad] = useMediaQuery("(max-width: 820px)");

  const {
    params: {deviceId},
  } = useMatch();

  const {data: {data: deviceDetails = {}} = {}, isLoading} = useGetDeviceApiDcimDevicesIdGet(deviceId, {
    query: {
      queryKey: ["bmDetails", deviceId],
    },
  });

  const actionMenuList = useMemo(() => {
    let list = [
      {
        label: "VPN Site",
        icon: <FiMonitor />,
        onClick: () => {
          window.open(deviceDetails.vpn_server, "_blank");
        },
      },
    ];
    return list;
  }, [deviceDetails]);

  return (
    <Box>
      <HeaderContainer>
        {isLoading ? <Loader /> : null}
        <Flex justifyContent={"space-between"} alignItems="start">
          <Box>
            <Heading fontSize={"20px"} fontWeight={700}>
              {deviceDetails?.display}
            </Heading>
          </Box>
          {isMobileOrIpad ? (
            <ActionMenu menuList={actionMenuList} />
          ) : (
            <HStack spacing={"10px"}>
              <Button as="a" href={deviceDetails.vpn_server} leftIcon={<FiMonitor />} size={"md"} target={"_blank"} variant={"brand"}>
                VPN Site
              </Button>
            </HStack>
          )}
        </Flex>
      </HeaderContainer>
    </Box>
  );
};

export default BaremetalDetailsHeader;
